<template>
    <div class="sustainability-page">
        <section class="sustainability-page__section">
            <div class="sustainability-page__banner sustainability-page-banner">
                <div class="container">
                    <div class="sustainability-page-banner__top">
                        <div class="sustainability-page-banner__content">
                            <z-caption
                                tag="p"
                                size="2xl"
                                weight="600"
                                class="sustainability-page-banner__text"
                            >
                                <p v-html="text.banner.text" />
                            </z-caption>
                            <z-button
                                tag="a"
                                size="l"
                                href="/sustainability/sdg-support/"
                                :is-circle-icon="false"
                                class="sustainability-page-banner__btn"
                            >
                                <span v-html="text.banner.button" />
                                <template v-slot:right>
                                    <z-icon
                                        name="arrow-long"
                                        dir="right"
                                        width="24"
                                        height="24"
                                    ></z-icon>
                                </template>
                            </z-button>
                        </div>
                        <div class="sustainability-page-banner__card">
                            <z-caption
                                tag="p"
                                size="xl"
                                weight="600"
                                theme="white"
                                class="sustainability-page-banner__card-title"
                            >
                                <p v-html="text.banner.card.title"/>
                            </z-caption>
                            <span
                                class="sustainability-page-banner__card-subtitle"
                                v-html="text.banner.card.subtitle"
                            ></span>
                            <a
                                :href="text.banner.card.link"
                                target="_blank"
                                class="sustainability-page-banner__card-link"
                            >
                                <z-icon
                                    name="arrow-long"
                                    dir="right"
                                    width="16"
                                    height="16"
                                ></z-icon>
                            </a>
                        </div>
                    </div>
                    <div class="sustainability-page-banner__bottom">
                        <z-blockquote
                            :author='{
                                name: text.banner.blockquote.name,
                                info: text.banner.blockquote.position
                            }'
                            :text="text.banner.blockquote.text"
                            horizontal
                            class="sustainability-page-banner__blockquote"
                        >
                            <template v-slot:avatar>
                                <z-avatar
                                    photo="/images/company/governance/board-of-management/potanin_obr.jpg"
                                    :name="text.banner.blockquote.name"
                                />
                            </template>
                        </z-blockquote>
                    </div>
                </div>
            </div>
        </section>

        <section class="sustainability-page__section">
            <reports :reports="preparedReports" />
        </section>

        <section class="sustainability-page__section">
            <presentations
                :presentations="preparedPresentation"
                :news="preparedNews"
            />
        </section>

        <section class="sustainability-page__section">
            <results-and-goals />
        </section>

        <section class="sustainability-page__section">
            <ratings />
        </section>

        <section class="sustainability-page__section">
            <div class="sustainability-page__projects sustainability-page-projects">
                <div class="container">
                    <z-caption
                        size="3xl"
                        decor-left
                        decor-right
                        class="sustainability-page-projects__title sustainability-page__title"
                    >
                        <span v-html="text.projects.title" />
                    </z-caption>

                    <div class="sustainability-page-projects__body">
                        <div
                            v-for="(project, index) in projects"
                            :key="index"
                            class="sustainability-page-projects__item"
                        >
                            <z-figure
                                theme="blue"
                                :top-text="index % 2 !== 0"
                                size="l"
                                :caption="project.title"
                                icon-name="external"
                                icon-dir="up"
                                icon-width="22"
                                icon-height="22"
                                :image="project.image"
                                :link="project.link"
                                external
                                class="sustainability-page-projects__figure"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="sustainability-page__section">
            <div class="sustainability-page__cases sustainability-page-cases">
                <div class="sustainability-page-cases__top">
                    <div class="container">
                        <z-caption
                            size="3xl"
                            decor-left
                            decor-right
                            class="sustainability-page-cases__title sustainability-page__title"
                        >
                            <span v-html="text.cases.title" />
                        </z-caption>
                    </div>
                </div>
                <slot name="cases-slider" />
            </div>
        </section>

        <section class="sustainability-page__section">
            <div class="sustainability-page__contacts sustainability-page-contacts">
                <div class="container">
                    <z-caption
                        tag="a"
                        size="3xl"
                        href="/sustainability/assessment/"
                        decor-left
                        class="sustainability-page-contacts__title sustainability-page__title"
                    >
                        <span v-html="text.contacts.title" />
                    </z-caption>

                    <div class="sustainability-page-contacts__body">
                        <div class="sustainability-page-contacts__item">
                            <z-link
                                size="2xl"
                                href="tel:+74957868320"
                                class="sustainability-page-contacts__link"
                            >
                            <template v-slot:left>
                                <div class="sustainability-page-contacts__icon">
                                    <z-icon
                                        name="phone"
                                        dir="top"
                                        width="32"
                                        height="32"
                                    ></z-icon>
                                </div>
                            </template>
                                +7 (495) 786-83-20
                            </z-link>
                        </div>
                        <div class="sustainability-page-contacts__item">
                            <z-link
                                size="2xl"
                                href="mailto:ESG@nornik.ru"
                                class="sustainability-page-contacts__link"
                            >
                            <template v-slot:left>
                                <div class="sustainability-page-contacts__icon">
                                    <z-icon
                                        name="message"
                                        dir="top"
                                        width="32"
                                        height="32"
                                    ></z-icon>
                                </div>
                            </template>
                                ESG@nornik.ru
                            </z-link>
                        </div>
                        <z-button
                            size="l"
                            kind="primary"
                            @click="$root.$bus.$emit('open-modal', { id: 'sustainabilityFormModal' })"
                            class="sustainability-page-contacts__btn"
                        >
                            <span v-html="text.contacts.button" />
                            <template v-slot:right>
                                <z-icon
                                    name="arrow-long"
                                    dir="right"
                                    width="24"
                                    height="24"
                                />
                            </template>
                        </z-button>
                    </div>
                </div>
            </div>
        </section>

        <z-modal
            ref="modal"
            id="sustainabilityFormModal"
            class="sustainability-page__contacts-form"
        >
            <z-caption
                tag="h3"
                size="2xl"
                icon="message"
            >
                <span v-html="text.contacts.formTitle" />
            </z-caption>
            <main-contacts-form @closeModal="closeModal" />
        </z-modal>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'
import Reports from './components/Reports.vue'
import Presentations from './components/Presentations.vue'
import ResultsAndGoals from './components/ResultsAndGoals.vue'
import Ratings from './components/Ratings.vue'

export default {
    name: 'sustainability-page',
    components: {
        Reports,
        Presentations,
        ResultsAndGoals,
        Ratings
    },
    props: {
        reportsList: {
            type: Array,
            default: () => [
                'white-book',
                'climate-report',
                'social-policy',
                'analytical-report',
                'csr',
                'ar',
                'corporate-social-politic',
                ''
            ]
        }
    },
    data () {
        return {
            lang: this.$root.lang,
            sustainabilityData: this.$root.app.components['sustainability-page'],
            annualReportsData: this.$root.app.components['annual-reports-block'],
            projects: [
                {
                    title: localize({
                        ru: 'Nornickel ESG Insights: <br/> Объединяем усилия для лучшего будущего',
                        en: 'Nornickel ESG Insights: <br/> Joining Forces for a&nbsp;Better Future'
                    }),
                    image: '/images/sustainability/new/project-future.webp',
                    link: localize({
                        ru: 'https://esg.nornickel.ru/',
                        en: 'https://esg.nornickel.com/'
                    })
                },
                {
                    title: localize({
                        ru: 'Уникальный веб-проект, посвящённый биоразнообразию: <br/> Как &laquo;Норникель&raquo; сохраняет экосистему?',
                        en: 'A&nbsp;Unique Web Project Dedicated to&nbsp;Biodiversity: <br/> How Is&nbsp;Nornickel Preserving the Ecosystem?'
                    }),
                    image: '/images/sustainability/new/project-ecology.webp',
                    link: localize({
                        ru: 'https://life.nornickel.ru/',
                        en: 'https://life.nornickel.com/'
                    })
                }
            ],
            text: {
                banner: {
                    text: localize({
                        ru: '&laquo;Норникель&raquo; формирует и&nbsp;реализует свою стратегию развития, ориентируясь на&nbsp;глобальные тренды, в&nbsp;первую очередь на&nbsp;переход к&nbsp;низкоуглеродной экономике, и&nbsp;запросы своих ключевых заинтересованных сторон: сотрудников, акционеров, инвесторов, потребителей',
                        en: 'Nornickel shapes and implements its development strategy, focusing on&nbsp;global trends, primarily the transition to&nbsp;a&nbsp;low-carbon economy, and the needs of&nbsp;its key stakeholders: employees, shareholders, investors, and consumers.'
                    }),
                    button: localize({
                        ru: 'Поддержка целей ООН в&nbsp;области устойчивого развития',
                        en: 'Support for the UN&nbsp;Sustainable Development Goals'
                    }),
                    card: {
                        title: localize({
                            ru: 'Стратегические приоритеты и&nbsp;цели Компании в&nbsp;области устойчивого развития',
                            en: 'Strategic Priorities and Goals of&nbsp;the Company in&nbsp;the Field of&nbsp;Sustainable Development'
                        }),
                        subtitle: localize({
                            ru: 'Экология и&nbsp;изменение климата <br/> до&nbsp;2031 года',
                            en: 'Environment and Climate Change <br/> Until 2031'
                        }),
                        link: localize({
                            ru: '/upload/iblock/1cd/Norilsk_Nickel_Environmental_Strategy_2021_ru.pdf',
                            en: '/upload/iblock/7b2/Norilsk_Nickel_Environmental_Strategy_2021_en.pdf'
                        })
                    },
                    blockquote: {
                        name: localize({
                            ru: 'Владимир Потанин',
                            en: 'Vladimir Potanin'
                        }),
                        position: localize({
                            ru: 'Президент ПАО &laquo;ГМК &laquo;Норильский никель&raquo;',
                            en: 'President of&nbsp;PJSC &laquo;MMC Norilsk Nickel&raquo;'
                        }),
                        text: localize({
                            ru: 'Устойчивое развитие для нас&nbsp;&mdash; это философия бизнеса, мировоззрение управленческих команд, корпоративная культура и&nbsp;долгосрочная ценностная платформа',
                            en: 'Sustainable development for&nbsp;us is&nbsp;a&nbsp;business philosophy, a&nbsp;worldview of&nbsp;management teams, corporate culture, and a&nbsp;long-term value platform.'
                        })
                    }
                },
                projects: {
                    title: localize({
                        ru: 'ESG веб-проекты',
                        en: 'ESG Web Projects'
                    })
                },
                cases: {
                    title: localize({
                        ru: 'ESG-кейсы',
                        en: 'ESG Cases'
                    })
                },
                contacts: {
                    title: localize({
                        ru: 'Контакты',
                        en: 'Contacts'
                    }),
                    button: localize({
                        ru: 'Связаться с&nbsp;нами',
                        en: 'Contact Us'
                    }),
                    formTitle: localize({
                        ru: 'Отправьте ваш вопрос',
                        en: 'Send your question'
                    })
                },
                reports: {
                    annual: localize({
                        ru: 'Годовой отчет',
                        en: 'Annual Report'
                    }),
                    csr: localize({
                        ru: 'Отчет об устойчивом развитии',
                        en: 'Sustainability Report'
                    })
                }
            }
        }
    },
    computed: {
        preparedReports () {
            if (!this.annualReportsData) return []
            const reports = []

            if (this.annualReportsData['annual-report'] && this.annualReportsData['annual-report'].arFile.link) {
                reports.push({
                    image: this.annualReportsData['annual-report'].arImg.link,
                    name: `${this.text.reports.annual} ${this.annualReportsData['annual-report'].name}`,
                    fileLink: this.annualReportsData['annual-report'].arFile.link,
                    onlineLink: this.annualReportsData['annual-report'].arUrl.value,
                    brochure: this.annualReportsData['annual-report'].brochure.link
                })
            }

            if (this.annualReportsData.csr && this.annualReportsData.csr.csrFile.link) {
                reports.push({
                    image: this.annualReportsData.csr.csrImg.link,
                    name: `${this.text.reports.csr} ${this.annualReportsData.csr.name}`,
                    fileLink: this.annualReportsData.csr.csrFile.link,
                    onlineLink: this.annualReportsData.csr.csrUrl.value,
                    brochure: this.annualReportsData.csr.brochure.link
                })
            }

            if (this.annualReportsData.additionalReports && this.annualReportsData.additionalReports.length) {
                this.annualReportsData.additionalReports
                    .filter(item => this.reportsList.includes(item.type.xmlId) && item.file.link)
                    .forEach(item => {
                        reports.push({
                            image: item.image.link,
                            name: item.name,
                            fileLink: item.file.link,
                            onlineLink: item.url.value,
                            brochure: item.brochure.link
                        })
                    })
            }

            return reports
        },
        preparedPresentation () {
            if (!this.sustainabilityData && this.sustainabilityData['presentation-and-briefings']) return []
            return this.sustainabilityData['presentation-and-briefings'].slice(0, 3)
        },
        preparedNews () {
            if (!this.sustainabilityData && this.sustainabilityData.news) return []
            return this.sustainabilityData.news.slice(0, 2)
        }
    },
    methods: {
        closeModal () {
            this.$refs.modal.closeModal({ id: 'sustainabilityFormModal' })
        }
    }
}
</script>

<style lang="scss">
.sustainability-page {
    &__title {
        &.z-caption {
            margin-top: $token-spacers-xl;

            @include breakpoint(v-tablet) {
                margin-top: $token-spacers-l;
            }

            @include breakpoint(mobile) {
                width: 100%;
                margin-bottom: $token-spacers-s;

                span.z-caption__arrow {
                    width: 24px;
                    height: 24px;
                }

                .z-icon {
                    width: 12px !important;
                    height: 12px !important;
                }
            }
        }
    }
}

.sustainability-page-banner {
    $parent: &;
    background-image: url(/images/sustainability/new/sustainability-banner.webp);
    background-repeat: no-repeat;
    background-size: cover;
    padding-bottom: $token-spacers-2-xl;

    @include breakpoint(tablet) {
        padding-bottom: $token-spacers-xl;

    }

    @include breakpoint(mobile) {
        background-image: url(/images/sustainability/new/sustainability-banner-mob.webp);
        background-position: center;
        padding-bottom: $token-spacers-l;
    }

    &__top {
        display: flex;
        justify-content: space-between;
        gap: $token-spacers-2-s;
        margin-bottom: $token-spacers-4-xl;

        @include breakpoint(tablet) {
            margin-bottom: $token-spacers-2-xl;
        }

        @include breakpoint(v-tablet) {
            flex-direction: column;
        }

        @include breakpoint(mobile) {
            gap: $token-spacers-m;
            margin-bottom: $token-spacers-l;
        }
    }

    &__content {
        max-width: 890px;
        flex: 1;
        padding-top: $token-spacers-m;

        @include breakpoint(tablet) {
            padding-top: $token-spacers-xs;
        }

        @include breakpoint(mobile) {
            padding-top: 0;
        }
    }

    &__text {
        p {
            line-height: 140%;
            letter-spacing: -0.12px;
            margin-bottom: $token-spacers-xl;

            @include breakpoint(tablet) {
                margin-bottom: $token-spacers-m;
            }

            @include breakpoint(mobile) {
                margin-bottom: $token-spacers-2-s;
            }
        }
    }

    &__btn {
        &.z-button {
            .z-button__icon {
                .z-icon {
                    transition: margin 0.25s linear;
                }
            }

            &:hover {
                .z-icon {
                    margin-inline-start: 16px;
                }
            }

            @include breakpoint(mobile) {
                font-size: 16px;
                text-align: start;
                padding: 5px $token-spacers-s !important;
            }
        }
    }

    &__card {
        max-width: 489px;
        flex: 1;
        flex-shrink: 0;
        border-radius: 0px 40px 0 40px;
        background: rgba(0, 69, 137, 0.80);
        color: $token-colors-white;
        padding: $token-spacers-2-s $token-spacers-2-s $token-spacers-l $token-spacers-2-s;
        position: relative;

        @include breakpoint(tablet) {
            max-width: 390px;
            min-width: 360px;
            padding: $token-spacers-s $token-spacers-s $token-spacers-l $token-spacers-s;
        }

        @include breakpoint(v-tablet) {
            max-width: 100%;
            min-width: 328px;
        }

        @include breakpoint(mobile) {
            border-radius: 0px 16px 0 16px;
            padding: $token-spacers-xs $token-spacers-xs $token-spacers-l $token-spacers-xs;
        }
    }

    &__card-title {
        line-height: 140%;
        margin-bottom: $token-spacers-2-s;

        @include breakpoint(tablet) {
            margin-bottom: $token-spacers-s;
        }

        @include breakpoint(mobile) {
            margin-bottom: $token-spacers-xs;
        }
    }

    &__card-subtitle {
        font-size: 20px;
        line-height: 140%;
        letter-spacing: -0.2px;

        @include breakpoint(tablet) {
            font-size: 18px;
        }

        @include breakpoint(mobile) {
            font-size: 16px;
        }
    }

    &__card-link {
        width: 36px;
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid $token-colors-white;
        position: absolute;
        bottom: 24px;
        inset-inline-end: 30px;
        transition: transform 0.3s ease-in-out;
        transform-origin: right;

        @include breakpoint(mobile) {
            bottom: 16px;
            inset-inline-end: 16px;
        }

        &:hover {
            transform: scale(1.1);
        }

        path {
            fill: $token-colors-white;
        }
    }

    &__blockquote {
        &.z-blockquote {
            padding: $token-spacers-m 60px $token-spacers-m 52px;

            @include breakpoint(mobile) {
                border-radius: $token-spacers-s 0px $token-spacers-2-xs 0px;
                padding: $token-spacers-xs $token-spacers-2-xs;
            }
        }

        .z-blockquote__author-name {
            @include breakpoint(mobile) {
                &:after {
                    display: none;
                }
            }

            span {
                font-size: 30px;

                @include breakpoint(mobile) {
                    font-size: 22px;
                }
            }
        }

        .z-blockquote__author-description {
            @include breakpoint(mobile) {
                margin-top: 0;
            }

            div {
                color: $token-colors-gray-60 !important;

                @include breakpoint(mobile) {
                    font-size: 16px;
                }
            }
        }

        blockquote {
            font-size: 24px;

            @include breakpoint(mobile) {
                font-size: 20px;
            }
        }
    }
}

.sustainability-page-projects {
    padding-bottom: $token-spacers-xs;

    @include breakpoint(mobile) {
        padding-bottom: 0;
    }

    &__body {
        display: flex;
        gap: $token-spacers-2-xs;

        @include breakpoint(v-tablet) {
            flex-direction: column;
        }
    }

    &__item {
        flex: 1;
    }

    &__item-title {
        display: none;
        font-size: 24px;
        font-weight: 600;
        line-height: 120%;
        color: $token-colors-gray-60;
        margin: $token-spacers-l 0 $token-spacers-s;

        @include breakpoint(v-tablet) {
            display: inline-block;
        }
    }
}

.sustainability-page-cases {
    padding-top: $token-spacers-3-xl;

    @include breakpoint(tablet) {
        padding-top: $token-spacers-3-xl;
    }

    @include breakpoint(mobile) {
        padding-top: 0;
    }

    &__top {
        display: none;

        @include breakpoint(mobile) {
            display: block;
        }
    }
}

.sustainability-page-contacts {
    padding-top: $token-spacers-2-xl;
    padding-bottom: $token-spacers-2-xl;

    @include breakpoint(v-tablet) {
        padding-top: $token-spacers-m;
        padding-bottom: $token-spacers-m;
    }

    @include breakpoint(mobile) {
        padding-top: 0;
        padding-bottom: $token-spacers-xs;
    }

    &__title {
        @include breakpoint(mobile) {
            &:before {
                display: none;
            }
        }
    }

    &__body {
        display: flex;
        padding-top: 38px;

        @include breakpoint(v-tablet) {
            flex-direction: column;
            align-items: flex-start;
        }

        @include breakpoint(mobile) {
            padding-top: 0;
        }
    }

    &__item {
        &:not(:last-of-type) {
            margin-right: $token-spacers-4-xl;

            @include breakpoint(laptop) {
                margin-right: $token-spacers-3-xl;
            }

            @include breakpoint(tablet) {
                margin-right: $token-spacers-l;
            }

            @include breakpoint(v-tablet) {
                margin-right: 0;
                margin-bottom: 8px;
            }
        }
    }

    &__link {
        &.z-link {
            @include breakpoint(mobile) {
                font-size: 20px;
            }
        }
    }

    &__icon {
        width: 42px;
        height: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid rgba(193, 198, 210, 0.3);
        border-radius: 50%;
        margin-right: $token-spacers-2-xs;

        @include breakpoint(mobile) {
            margin-right: $token-spacers-3-xs;
        }
    }

    &__btn {
        margin-left: 180px;

        @include breakpoint(laptop) {
            margin-left: $token-spacers-3-xl;
        }

        @include breakpoint(tablet) {
            margin-left: $token-spacers-l;
        }

        @include breakpoint(v-tablet) {
            margin-top: $token-spacers-s;
            margin-left: 0;
        }
    }
}
</style>
